import React from 'react';
import { IContent } from 'vev';
import { useWidget } from '../core';

type ComponentProps = {
  section?: boolean;
  model: IContent;
  children?: React.ReactNode;
  className?: string;
  id?: string;
  hostRef: React.RefObject<HTMLDivElement>;
};

export function CodedComponent({
  hostRef,
  className,
  id,
  model,
  section,
  children,
}: ComponentProps) {
  const Comp = useWidget(model.type);
  if (!Comp) return null;

  if (children)
    return (
      <Comp id={id} className={className} section={section} hostRef={hostRef} {...model.content}>
        {children}
      </Comp>
    );

  return (
    <Comp id={id} className={className} section={section} hostRef={hostRef} {...model.content} />
  );
}
